module.exports = {"TXTWCL_Previous_Odds":{"id":"TXTWCL_Previous_Odds","defaultMessage":"Tidligere odds"}}